module.exports = __webpack_public_path__ + "static/media/electromovilidad_buses.dfe4c2d4.png";